import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const insights = [
    {
        title: "Where they live",
        color: "bg-green-700",
        items: [
            { label: "United States", value: 223 },
            { label: "California, United States", value: 116 },
            { label: "San Francisco Bay Area", value: 104 },
            { label: "San Francisco, CA", value: 71 },
            { label: "New York City Metropolitan Area", value: 46 },
        ],
    },
    {
        title: "Where they studied",
        color: "bg-teal-700",
        items: [
            { label: "UC Berkeley", value: 17 },
            { label: "Stanford University", value: 9 },
            { label: "Princeton University", value: 7 },
            { label: "Harvard University", value: 6 },
            { label: "General Assembly", value: 6 },
        ],
    },
    {
        title: "What they do",
        color: "bg-indigo-700",
        items: [
            { label: "Engineering", value: 40 },
            { label: "Product", value: 25 },
            { label: "Design", value: 20 },
            { label: "Marketing", value: 15 },
        ],
    },
    {
        title: "What they are skilled at",
        color: "bg-purple-700",
        items: [
            { label: "React", value: 30 },
            { label: "Node.js", value: 25 },
            { label: "UI/UX", value: 20 },
            { label: "AI/ML", value: 15 },
        ],
    },
];

const members = Array.from({ length: 12 }).map((_, i) => ({
    id: i + 1,
    name: i % 3 === 0 ? "Biswajit Biswas" : "Spryhub Member",
    title:
        i % 3 === 0
            ? "Support@LangChain"
            : i % 3 === 1
                ? "Software Engineer @LangChain"
                : "Teaching Developers to Build AI Agents",
    mutual: `${Math.floor(Math.random() * 10)} mutual`,
    avatar: i % 2 === 0 ? `https://i.pravatar.cc/150?img=${i + 1}` : null,
    cover: `https://picsum.photos/300/100?random=${i + 1}`,
}));

const CompanyPeopleTab = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [swiperInstance, setSwiperInstance] = useState(null);

    const handleSwiperInit = (swiper) => {
        setSwiperInstance(swiper);
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
        swiper.navigation.destroy();
        swiper.navigation.init();
        swiper.navigation.update();
    };

    return (
        <div className="space-y-6">
            {/* INSIGHTS SLIDER */}
            <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold">290 associated members</h2>

                    <div className="flex justify-between md:justify-normal gap-2">
                        <button
                            ref={prevRef}
                            className="px-3 py-1 text-sm font-medium rounded  text-gray-600 hover:text-gray-800 cursor-pointer select-none disabled:opacity-40"
                        >
                            <i class="fa-solid fa-angle-left mr-1"></i> Prev
                        </button>
                        <button
                            ref={nextRef}
                            className="px-3 py-1 text-sm font-medium rounded  text-gray-600 hover:text-gray-800 cursor-pointer select-none disabled:opacity-40"
                        >
                            Next <i class="fa-solid fa-angle-right ml-1"></i>
                        </button>
                    </div>
                </div>

                <input
                    placeholder="Search employees by title, keyword or school"
                    className="w-full mb-5 border rounded-md px-3 py-2 text-sm border-zinc-300"
                />

                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={10}
                    slidesPerView={1}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    pagination={{ clickable: true }}
                    onSwiper={handleSwiperInit}
                    breakpoints={{
                        768: { slidesPerView: 2 },
                    }}
                    className="pb-8 jobs-swiper"
                >
                    {insights.map((section, i) => {
                        const max = Math.max(...section.items.map((i) => i.value));

                        return (
                            <SwiperSlide key={i}>
                                <div className="border rounded-lg p-4 h-full">
                                    <div className="flex justify-between mb-3">
                                        <h3 className="font-medium text-sm">{section.title}</h3>
                                        <button className="text-xs text-gray-500">+ Add</button>
                                    </div>

                                    <div className="space-y-3">
                                        {section.items.map((item, idx) => {
                                            const percent = (item.value / max) * 100;

                                            return (
                                                <div key={idx}>
                                                    <div className="flex justify-between text-xs mb-1">
                                                        <span>{item.label}</span>
                                                        <span className="text-gray-500">{item.value}</span>
                                                    </div>

                                                    <div className="w-full bg-gray-200 h-2 rounded">
                                                        <div
                                                            className={`${section.color} h-2 rounded`}
                                                            style={{ width: `${percent}%` }}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>



            {/* PEOPLE GRID */}
            <div className="p-4 border rounded-lg bg-white shadow-md mb-5">
                <h2 className="text-lg font-semibold mb-4">People you may know</h2>

                <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {members.map((user) => (
                        <div
                            key={user.id}
                            className="border rounded-lg overflow-hidden hover:shadow-md transition"
                        >
                            <div className="h-16 bg-gray-200 overflow-hidden">
                                {user.cover ? (
                                    <img
                                        src={user.cover}
                                        alt="cover"
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <div className="w-full h-full bg-gray-200" />
                                )}
                            </div>
                            <div className="flex flex-col items-center px-3 pb-4 -mt-8">
                                {user.avatar ? (
                                    <img
                                        src={user.avatar}
                                        className="w-16 h-16 rounded-full border-2 border-white object-cover"
                                    />
                                ) : (
                                    <div className="w-16 h-16 rounded-full bg-gray-400 text-white flex items-center justify-center text-xl font-semibold border-2 border-white">
                                        {user.name.charAt(0)}
                                    </div>
                                )}

                                <h3 className="mt-2 text-sm font-semibold text-center">
                                    {user.name}
                                </h3>
                                <p className="text-xs text-gray-500 text-center line-clamp-2">
                                    {user.title}
                                </p>

                                <p className="text-xs text-gray-400 mt-1">
                                    {user.mutual}
                                </p>

                                <button className="mt-3 text-sm border border-blue-600 text-blue-600 px-4 py-1 rounded-full hover:bg-blue-50">
                                    Message
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CompanyPeopleTab;
